export default class ClosingTime {
    constructor() {
        this.id = null;
        this.type = null;
        this.start = null;
        this.end = null;
        this.deleted = false;
    }
    clone() {
        const clone = new ClosingTime();
        clone.id = this.id;
        clone.type = this.type;
        clone.start = this.start;
        clone.end = this.end;
        clone.deleted = this.deleted;
        return clone;
    }
    serialize() {
        return {
            id: this.id,
            type: this.type,
            start: this.start ? this.start.toIso8601() : null,
            end: this.end ? this.end.toIso8601() : null,
            deleted: this.deleted,
        }
    }
}
